import { get } from 'lodash'
export default function getAddress (user) {
  const addresses = get(user, 'user_info.profile.contacts.address', [])
  const primaryAddress = addresses[0]
  const primaryAddressValue = primaryAddress ? primaryAddress.address.address.display : ''
  return primaryAddressValue
}
